(() => {
  if (window.KslFeedback) return;
  const strings = () => window.kslFeedbackStrings || {};
  const showError = (container, message, href, label) => {
    if (!container) return;
    container.classList.add('ksl-notice');
    container.setAttribute('role', 'alert');
    const text = document.createElement('p');
    text.textContent = message;
    container.replaceChildren(text);
    if (href && label) {
      const url = new URL(href, location.origin);
      if (url.origin === location.origin) {
        const link = document.createElement('a');
        link.className = 'link underlined-link';
        link.href = url.href;
        link.textContent = label;
        container.append(link);
      }
    }
  };
  window.KslFeedback = { showError };
  let nextId = 0;
  const errors = new WeakMap();
  const supported = input => input.form?.matches('.contact form, .newsletter-form, .footer__newsletter form, .footer-block__newsletter form');
  document.addEventListener('invalid', event => {
    const input = event.target;
    if (!supported(input)) return;
    event.preventDefault();
    let record = errors.get(input);
    if (!record) {
      const error = document.createElement('small');
      error.id = `KslFieldError-${++nextId}`;
      error.className = 'ksl-field-error';
      error.setAttribute('role', 'alert');
      record = { error, describedBy: input.getAttribute('aria-describedby'), invalid: input.getAttribute('aria-invalid') };
      errors.set(input, record);
      (input.closest('.field') || input).after(error);
    }
    record.error.textContent = input.validity.valueMissing ? strings().fieldRequired : input.type === 'email' ? strings().emailInvalid : strings().fieldInvalid;
    input.classList.add('ksl-input-error');
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', [record.describedBy, record.error.id].filter(Boolean).join(' '));
    input.focus();
  }, true);
  document.addEventListener('input', event => {
    const input = event.target, record = errors.get(input);
    if (!record || !input.validity.valid) return;
    record.error.remove();
    input.classList.remove('ksl-input-error');
    for (const [name, value] of [['aria-describedby', record.describedBy], ['aria-invalid', record.invalid]]) {
      if (value === null) input.removeAttribute(name); else input.setAttribute(name, value);
    }
    errors.delete(input);
  });
})();
